import React, { useMemo } from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import FourthPageStore from '@src/pages/main/components/fourth-page/store';
import BaseSwiper from '@src/components/swiper/base-swiper';
import styles from './index.less';
import { isType } from '@src/utils/common-util';

/**
 * FourthPage
 * @param store {FourthPageStore}
 * @returns {JSX.Element}
 * @constructor
 */
const FourthPage = ({ store }) => {
  const { layerData, currentMecha, localData } = store;
  const { mecha_list } = layerData;
  const pageShowStateClass = [styles.playInAnimate, styles.leaveInAnimate, ''];
  store.use();

  const RenderRootBg = useMemo(() => {
    return (
      <div className={cx(styles.rootBg)} data-name="背景">
        <div className={styles.bgGride} data-name="网格" />
        <div className={styles.bgPoint} data-name="网点" />
        <div className={styles.bgLogo} data-name="logo" />
        <div className={cx(styles.lineGroup)} data-name="线">
          <div className={cx(styles.line1)} data-name="线条1" />
          <div className={styles.line2Group}>
            <div className={cx(styles.line2)} data-name="线条2" />
          </div>
          <div className={cx(styles.line3)} data-name="线条3" />
        </div>
        <div className={styles.decoration} data-name="小装饰" />
        <div className={styles.mechaText} data-name="mecha info" />
      </div>
    );
  }, []);

  return (
    <div className={cx(styles.root, pageShowStateClass[store.pageShowState])}>
      <div className={styles.rootWrap}>
        {RenderRootBg}
        <div data-name="机甲轮播模块" className={cx(styles.mechaSwiperBox, 'mecha-swiper-box')}>
          {mecha_list.length > 0 && (
            <BaseSwiper store={store.mechaSwiper}>
              {mecha_list.map(item => {
                return (
                  <div key={item.mecha_name} className={cx(styles.swiperItem, 'mecha-swiper-item')}>
                    {/* 机甲图片信息 */}
                    <React.Fragment>
                      <div data-name={`机甲 - ${item.mecha_name}`} className={cx(styles.mechaGroup)}>
                        <div data-name="立绘" className={styles.mechaImg}>
                          <img className="mecha-img" alt={item.mecha_name} data-src={item.mecha_image} data-other-src={item.mecha_other_state_image} src="" />
                          {item.mecha_other_state_image && <img alt={item.mecha_name} src={item.mecha_other_state_image} style={{}} />}
                        </div>
                        <img alt={item.mecha_name} src={item.mecha_gray_bg} className={styles.mechaGrayBg} />
                      </div>
                    </React.Fragment>
                    {/* 机甲内容信息 */}
                    <div className={styles.contentGroup}>
                      <div data-name="当前轮播索引" className={styles.swiperActiveIndex}>
                        <span>{(store.mechaSwiper.activeIndex + 1 + '').padStart(2, '0')}</span>
                        <span>/</span>
                        <span>{mecha_list.length}</span>
                      </div>
                      <div data-name="光影条组" className={styles.lightGrup}>
                        <div className={styles.light1} />
                        <div className={styles.light2} />
                        <div className={styles.light3} />
                      </div>
                      <div data-name="机甲序号|查看详情按钮" className={styles.numDetailBtnGroup}>
                        <div data-name="机甲序列号组" className={styles.mechaNumGroup}>
                          <img alt="" data-name="装饰线条" className={styles.decorationLine} src={require('./images/mechSwiper/content-decoration-4.png')} />
                          <div data-name="机甲序列号" className={styles.numText}>
                            {item.mecha_number}
                          </div>
                        </div>
                        <div data-name="查看详情按钮" className={styles.detailBtn} onClick={() => store.toDetail()}>
                          <img alt="" src={localData.mecha_detail_btn} />
                        </div>
                      </div>
                      <div className={styles.mechaNameWrap}>
                        <div data-name="机甲名称" className={styles.mechaName}>
                          {item.mecha_name}
                        </div>
                        <div data-name="作战类型组" className={styles.mechaTypeGroup}>
                          <div data-name="lable" className={styles.lable}>
                            {item.mecha_type}
                          </div>
                          <div data-name="类型标签" className={styles.typeTag}>
                            <span className={styles.mechaTag1}>{item.mecha_tag_1}</span>
                            <span className={styles.xiegan} />
                            <span className={styles.mechaTag2}>{item.mecha_tag_2}</span>
                          </div>
                        </div>
                      </div>
                      <img alt="" data-name="机甲英文图片" className={styles.mechEnName} src={item.mecha_id_image} />
                    </div>
                    {/* 机甲形态切换 */}
                    <div data-name="机甲形态切换" className={styles.mechaTypeChang}>
                      {store.isOtherMechaType ? (
                        <img
                          alt=""
                          className={cx(styles.normal, styles.typeImg)}
                          src={currentMecha.mecha_state_btn}
                          onClick={() => {
                            store.isOtherMechaType = false;
                          }}
                        />
                      ) : (
                        <img alt="" className={cx(styles.normal, styles.typeAct, styles.typeImg)} src={currentMecha.mecha_state_act_btn} />
                      )}
                      {currentMecha.mecha_other_state_image && (
                        <React.Fragment>
                          {store.isOtherMechaType ? (
                            <img alt="" className={cx(styles.other, styles.typeAct, styles.typeImg)} src={currentMecha.mecha_other_state_act_btn} />
                          ) : (
                            <img
                              alt=""
                              className={cx(styles.other, styles.typeImg)}
                              src={currentMecha.mecha_other_state_btn}
                              onClick={() => {
                                store.isOtherMechaType = true;
                              }}
                            />
                          )}
                        </React.Fragment>
                      )}
                    </div>
                  </div>
                );
              })}
            </BaseSwiper>
          )}
        </div>
        <div data-name="轮播缩略图轮播控制模块" className={styles.slideChangeControl}>
          <div className={styles.thumbSwiperGroup}>
            <div data-name="上一张" className={cx(styles.prevControl, styles.changeControl)} onClick={store.versionTabSwiper.goPrev} />
            <div className={styles.thumbSwiperBox} onClick={store.setVersionSwiperIndex}>
              {isType(mecha_list, 'Array') &&
                mecha_list.length > 0 && (
                  <BaseSwiper store={store.versionTabSwiper}>
                    {mecha_list.map((item, index) => {
                      return (
                        <div key={item.mecha_name} data-name={`机甲 - ${item.mecha_name}`} className={styles.slideItem}>
                          <div data-name="默认状态" className={styles.normal} style={{ backgroundImage: `url(${item.mecha_tab_icon})` }} />
                          <div data-name="选择状态" className={styles.hover} style={{ backgroundImage: `url(${item.mecha_tab_icon_hov})` }} />
                          <div data-name="激活状态" className={styles.activeGroup}>
                            <div className={styles.wrap}>
                              <div data-name="选中框左上角装饰" className={styles.decoration} />
                              <div
                                data-index={index}
                                data-name="激活状态图片"
                                className={styles.active}
                                style={{ backgroundImage: `url(${item.mecha_tab_icon_act})` }}
                              />
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </BaseSwiper>
                )}
            </div>
            <div data-name="下一张" className={cx(styles.nextControl, styles.changeControl)} onClick={store.versionTabSwiper.goNext} />
          </div>
        </div>
        <div datga-name="前往机甲列表" className={styles.toMechalistGroup}>
          <img alt="" className={styles.line} src={require('./images/slidSwiper/to-mech-list-line.png')} />
          <img alt="" className={styles.toMechaListBtn} src={localData.mecha_list_btn} onClick={() => store.toMechaList()} />
        </div>
        <div data-name="当前轮播索引" className={styles.footerSwiperActiveIndex}>
          <span className={styles.active}>{(store.versionTabSwiper.activeIndex + 1 + '').padStart(2, '0')}</span>
          <span>/</span>
          <span>{mecha_list.length}</span>
        </div>
      </div>
    </div>
  );
};

export default wrapStore(FourthPage, FourthPageStore);
